import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { Box, Grid, Text } from '@chakra-ui/react';
import { styles } from './datepicker-component.styles';
import './datepicker-component.scss';
import { Button } from '../button/button';
import { ButtonVariant } from '../../core/enums';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
const DatePickerHeader = (props)=>{
    const { onMonthClick, onMonthPickerYearClick, onYearClick, onRightArrowClick, onLeftArrowClick, handleClearDate, monthDate, dayPicker, monthPicker, yearPicker, yearRange, selectedYear, isClearBtnDisabled } = props;
    const classes = styles();
    const getMonthAndYear = useCallback(()=>{
        return monthDate?.toLocaleString('en-US', {
            month: 'long',
            year: 'numeric'
        }).split(' ') ?? null;
    }, [
        monthDate
    ]);
    const month = getMonthAndYear() && getMonthAndYear()[0];
    const year = getMonthAndYear() && getMonthAndYear()[1];
    return /*#__PURE__*/ _jsx("div", {
        className: "datepicker-component",
        children: /*#__PURE__*/ _jsxs(Box, {
            sx: classes.root,
            children: [
                /*#__PURE__*/ _jsxs(Grid, {
                    sx: classes.header,
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            onClick: onLeftArrowClick,
                            children: /*#__PURE__*/ _jsx(BiomeIcon, {
                                iconName: IconName.Chevron_Left,
                                iconClass: `${classes.icon}`,
                                iconSize: "12"
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Grid, {
                            sx: classes.title,
                            children: [
                                dayPicker && /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            className: "react-datepicker__current-month",
                                            style: classes.icon,
                                            onClick: onMonthClick,
                                            children: month
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            className: "react-datepicker__current-month",
                                            style: classes.icon,
                                            onClick: onYearClick,
                                            children: year
                                        })
                                    ]
                                }),
                                yearPicker && /*#__PURE__*/ _jsx(Text, {
                                    className: "react-datepicker__current-month",
                                    children: yearRange
                                }),
                                monthPicker && /*#__PURE__*/ _jsx(Text, {
                                    className: "react-datepicker__current-month",
                                    onClick: onMonthPickerYearClick,
                                    style: classes.icon,
                                    children: selectedYear
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            onClick: onRightArrowClick,
                            children: /*#__PURE__*/ _jsx(BiomeIcon, {
                                iconName: IconName.Chevron_Right,
                                iconSize: "12",
                                iconClass: `${classes.icon}`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(Button, {
                        label: 'Clear',
                        variant: ButtonVariant.LINKS,
                        onClick: handleClearDate,
                        sx: isClearBtnDisabled ? classes.disabledBtn : classes.clearBtn
                    })
                })
            ]
        })
    });
};
DatePickerHeader.displayName = 'DatePickerHeader';
export { DatePickerHeader };
